import { render, staticRenderFns } from "./SelectTuevsMaterial.vue?vue&type=template&id=d64daf60&scoped=true&"
import script from "./SelectTuevsMaterial.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64daf60",
  null
  
)

export default component.exports